import * as React from 'react';
import { Svg } from './Svg.js';
export const SvgCheckmarkSmall = (props) =>
  React.createElement(
    Svg,
    props,
    React.createElement('path', {
      d: 'm6 13.4-4.7-4.7 1.4-1.4 3.3 3.3 7.3-7.3 1.4 1.4z',
    }),
  );
